
export default function About() {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h3 className="text-4xl font-bold text-gray-900 mb-6">
              Redefining Cannabis Culture for Elite Events
            </h3>
            <p className="text-lg text-gray-600 mb-6">
              Elite Rolling Services was founded on the principle that cannabis consumption 
              should be elevated to an art form. We specialize in creating sophisticated, 
              discreet experiences for high-end private events, corporate gatherings, and 
              exclusive celebrations.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              Our team of professional rolling artists brings years of expertise and an 
              unwavering commitment to quality, ensuring every joint is crafted to perfection 
              while maintaining the utmost discretion and professionalism.
            </p>
            
            <div className="grid grid-cols-2 gap-8">
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-2">500+</div>
                <div className="text-gray-600">Events Served</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-2">100%</div>
                <div className="text-gray-600">Client Satisfaction</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-2">24/7</div>
                <div className="text-gray-600">Concierge Support</div>
              </div>
              <div className="text-center">
                <div className="text-3xl font-bold text-emerald-600 mb-2">5★</div>
                <div className="text-gray-600">Average Rating</div>
              </div>
            </div>
          </div>
          
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/ea9ee63e2601a97d8658510b8b06a49f.jpg"
              alt="Professional rolling artist at work"
              className="rounded-2xl shadow-2xl object-cover w-full h-[600px] object-top"
            />
            <div className="absolute -bottom-6 -left-6 bg-emerald-500 text-white p-6 rounded-xl shadow-lg">
              <div className="text-2xl font-bold">Premium Quality</div>
              <div className="text-emerald-100">Guaranteed Excellence</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
